import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-empty-state',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './empty-state.component.html',
    styleUrl: './empty-state.component.css'
})
export class EmptyStateComponent {
    @Input() title: string = 'No Records Found';
    @Input() description: string = 'There are no records to display at the moment.';
    @Input() imagePath: string = 'assets/no-records.gif';
    @Input() imageWidth: string = '200px';
    @Input() imageHeight: string = '200px';
    @Input() minHeight: string = '400px';
}
